import type { FaireProductEntity } from "../../entity_types/product";

export const p_85x7wws9sy: FaireProductEntity = {
  token: "p_85x7wws9sy",
  type: "product",
  name: "Metal Red Rustic Star Decor with Weathered Finish",
  brandName: "Iron & Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/67f2496c4cb6a60cefb448ebcd8ced9bc656529e9e21fb9dd742eabe31f1b636.jpeg",
  priceDollars: 14,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/df2bb9a3d6d724ed0d5b18a0513de3c54099c07a1ed3104c37d3acee0f045b37.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
